exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/*! _variables 07/02/2018  // (C) IHG. All rights reserved. */\n/*! _variables 07/02/2018  // (C) IHG. All rights reserved. */.hotel-reservation-header{width:100%;min-height:40px}[dir] .hotel-reservation-header{background-color:#3f3d3d;padding:0}@media (min-width:992px){.hotel-reservation-header{min-height:60px}}.hotel-reservation-header .confirmation-number{color:#ebebeb}[dir] .hotel-reservation-header .confirmation-number{padding:13px 15px 0 15px}@media (min-width:992px){[dir=ltr] .hotel-reservation-header .confirmation-number{padding:22px 0 0 30px}[dir=rtl] .hotel-reservation-header .confirmation-number{padding:22px 30px 0 0}}[dir] .hotel-info-section{background:#f4f2ed;padding-top:30px;padding-bottom:25px}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/main/webapp/stay-mgmt/app/components/hotel-reservation-details/hotel-reservation-details.component.scss
// module id = ./src/main/webapp/stay-mgmt/app/components/hotel-reservation-details/hotel-reservation-details.component.scss
// module chunks = 0